<div class="home__feed--container">
  <div class="home__feed--header">
    <h2>Latest News</h2>
  </div>
  <div class="home__feed--posts">
    @for (article of articles; track article.id; let i = $index) {
      @if (currentPost === i) {
        <article class="home__feed--post" [routerLink]="['/news', article.id]">
          <h3>{{article.attributes.title}}</h3>
          <p>{{article.attributes.summary}}</p>
        </article>
      }
    }
  </div>
</div>
